const LIMITED_HANDLE = '56-drawer';

async function enforceLimit() {
  const response = await fetch('/cart.js');
  const cart = await response.json();

  for (const item of cart.items) {
    if (item.handle === LIMITED_HANDLE && item.quantity > 1) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: 1 })
      });
      alert('Sorry, the 56" Drawer is limited to 1 per order. You may order another in a separate transaction. Thank you!');
      window.location.reload();
      return;
    }
  }
}

enforceLimit();